import { Button } from "@/components/ui/button";
import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";
import { Separator } from "@/components/ui/separator";
import { PencilIcon } from "lucide-react";
import { useState } from "react";
import SRBSettingsForm from "../../modal/my-business/srb-settings-form";

interface SRBSettingsProps {
  setting?: Record<string, string>,
  title: string,
  refetch: () => void
}

export default function SRBSettings({ setting, title, refetch }: SRBSettingsProps) {
  const [isOpen, setOpen] = useState(false);
  const [action, setAction] = useState<"add" | "edit">("add");
  const [data, setData] = useState<Record<string, string> | undefined>(setting);

  const handleEdit = () => {
    console.log("Edit notification:", setting);
    setAction("edit");
    setData(setting);
    setOpen(true);
    // Add your edit logic here
  };


  return (
    <Card className="w-full ">
      <CardHeader className="flex flex-row items-center justify-between px-6 py-2">
        <CardTitle>SRB Settings</CardTitle>
        <Button
          size="icon"
          variant="ghost"
          className="rounded-lg bg-primary p-2 shadow-sm hover:bg-primary/90 h-8 w-8"
          onClick={() => handleEdit()}

        >
          <PencilIcon className="h-4 w-4" />
        </Button>
      </CardHeader>
      <CardContent>
        <Separator className="h-[1px]" />
        <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-5 mt-2">
          <div className="space-y-1">
            <p className="text-xs ">API Key:</p>
            <p className="text-xs text-muted-foreground capitalize break-all">{setting?.api_key}</p>
          </div>
          <div className="space-y-1">
            <p className="text-xs ">API URL</p>
            <p className="text-xs text-muted-foreground break-all">{setting?.api_url}</p>
          </div>
          <div className="space-y-1">
            <p className="text-xs ">POS ID:</p>
            <p className="text-xs text-muted-foreground">{setting?.pos_id}</p>
          </div>
          <div className="space-y-1">
            <p className="text-xs ">NTN:</p>
            <p className="text-xs text-muted-foreground">{setting?.ntn}</p>
          </div>
          <div className="space-y-1">
            <p className="text-xs ">Username:</p>
            <p className="text-xs text-muted-foreground">{setting?.username}</p>
          </div>
          <div className="space-y-1">
            <p className="text-xs ">Org Name:</p>
            <p className="text-xs text-muted-foreground">{setting?.org_name}</p>
          </div>
        </div>
      </CardContent>
      <SRBSettingsForm
        editModeData={data}
        isOpen={isOpen}
        setOpen={setOpen}
        action={action}
        setAction={setAction}
        refetch={refetch}
      />
    </Card>
  );
}
